import React, { useState, useEffect } from "react";

function IncomeExpenses({ crmData = {}, updateCrmData, onNext, onBack }) {
  const [items, setItems] = useState([]);

  // Load existing income from crmData
  useEffect(() => {
    if (Array.isArray(crmData.income) && crmData.income.length > 0) {
      setItems(crmData.income);
    }
  }, [crmData]);

  const incomeCategories = [
    "Base Salary",
    "Bonus",
    "Overtime",
    "Rental Income",
    "Other",
  ];

  const frequencyOptions = ["Annual", "Monthly", "Fortnightly", "Weekly"];

  const addItem = () => {
    setItems([
      ...items,
      { category: "", owner: "Applicant 1", amount: "", frequency: "Annual" },
    ]);
  };

  const updateItem = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  const totalIncome = items.reduce((sum, i) => {
    if (!i.amount) return sum;
    const amt = parseFloat(i.amount) || 0;
    switch (i.frequency) {
      case "Monthly":
        return sum + amt * 12;
      case "Fortnightly":
        return sum + amt * 26;
      case "Weekly":
        return sum + amt * 52;
      default: // Annual
        return sum + amt;
    }
  }, 0);

  const handleContinue = () => {
    if (updateCrmData) {
      updateCrmData({ income: items });
    }
    if (onNext) onNext();
  };

  return (
    <div>
      <h2>Income & Expenses</h2>

      {/* Totals summary */}
      <div style={{ display: "flex", gap: "2rem", marginBottom: "1rem" }}>
        <div>
          <strong>Total Income</strong>
          <br />${totalIncome.toLocaleString()}
        </div>
      </div>

      {/* Income rows */}
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          {/* Category */}
          <select
            value={item.category}
            onChange={(e) => updateItem(index, "category", e.target.value)}
          >
            <option value="">Select Category</option>
            {incomeCategories.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          {/* Owner */}
          <select
            value={item.owner}
            onChange={(e) => updateItem(index, "owner", e.target.value)}
          >
            <option value="Applicant 1">Applicant 1</option>
            <option value="Applicant 2">Applicant 2</option>
          </select>

          {/* Amount */}
          <input
            type="number"
            placeholder="$"
            value={item.amount}
            onChange={(e) => updateItem(index, "amount", e.target.value)}
          />

          {/* Frequency */}
          <select
            value={item.frequency}
            onChange={(e) => updateItem(index, "frequency", e.target.value)}
          >
            {frequencyOptions.map((f) => (
              <option key={f} value={f}>
                {f}
              </option>
            ))}
          </select>

          {/* Remove */}
          <button onClick={() => removeItem(index)} style={{ color: "red" }}>
            ❌
          </button>
        </div>
      ))}

      <br />
      <button
        onClick={addItem}
        style={{ background: "#4EDCF6", padding: "8px 12px" }}
      >
        + Add Income / Expense
      </button>

      <br />
      <br />
      <button onClick={onBack}>⬅️ Back</button>
      <button onClick={handleContinue} style={{ marginLeft: "10px" }}>
        Continue ➡️
      </button>
    </div>
  );
}

export default IncomeExpenses;
